// extracted by mini-css-extract-plugin
module.exports = {"main":"Manager_main__33Tt8","noteContainer":"Manager_noteContainer__2M4Qn"};